<template>
  <div class="interactive">

  </div>
</template>

<script>
  export default{
    name:"interactive"
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/interactive.vue